const Config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.joinfruit.com',
  STORAGE_KEY: 'JOINFRUIT',
  shadow: {
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)'
  },
  textColor: '#1F2933',
  logo: require('../Assets/sanifrutta-logo.png'),
  appVersion: '0.0.3',
  userTypes: {
    ADMIN: 'admin',
    SYSTEM: 'system',
    USER: 'user',
    TECNICI: 'tecnici'
  }
}

export const isMaintenanceOnlyUser = type => type === Config.userTypes.TECNICI

export const canAccessMaintenance = type => [
  Config.userTypes.ADMIN,
  Config.userTypes.SYSTEM,
  Config.userTypes.TECNICI
].includes(type)

export const canAccessRoute = (path, userType) => {
  if (isMaintenanceOnlyUser(userType)) {
    return path === '/maintenance'
  }

  if (path === '/maintenance') {
    return canAccessMaintenance(userType)
  }

  return true
}

export default Config
